/**
 * DiscountDropdown has a button open/close a dropdown component.
 * @param {boolean} open - Whether or not the dropdown menu should be open.
 * @param {function} toggleOpen - A function to invoke when the button in pressed. Should flip the 'open' boolean.
 * @param {(function|function[])} children - The contents to be rendered inside the dropdown. Here, 'function' means a React component.
 */
import PropTypes from "prop-types"
import React from "react"

class DiscountDropdown extends React.Component {
  render() {
    return (
      <div>
        <button
          type="button"
          className={
            "text-link flex flex-row items-center justify-between font-semibold"
          }
          onClick={this.props.toggleOpen}
        >
          Add Discount
          <i
            className={"icon icon-caret-down m-0 ml-1"}
            style={{ fontSize: "0.7em" }}
            aria-label={`${this.props.open ? "open" : "closed"}`}
          />
        </button>
        {this.props.open && (
          <div
            onClick={this.props.toggleOpen}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
            className={"bg-transparent"}
          />
        )}
        <div className="absolute">
          {this.props.open && (
            <div className="relative z-10 mt-2 rounded-sm border bg-white p-4 shadow-lg">
              {this.props.children}
            </div>
          )}
        </div>
      </div>
    )
  }
}

DiscountDropdown.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.func.isRequired,
  children: PropTypes.node,
}

export default DiscountDropdown
